export const preloadImages = (imagePaths) => {
    const loadedImages = {};
    imagePaths.forEach((path) => {
      const img = new Image();
      img.src = path;
      loadedImages[path] = img;
    });
    return loadedImages;
  };